import React, { useState } from "react";

const Rating = ({ itemId, itemName, onRate }) => {
  const [hover, setHover] = useState(0);
  const [rating, setRating] = useState(0); // Default rating is 0 (not rated)

  const handleClick = (value) => {
    setRating(value); // Set the clicked rating
    onRate(itemId, itemName, value); // Notify parent about the rating
  };

  return (
    <div className="rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${star <= (hover || rating) ? "filled" : ""}`}
          onClick={() => handleClick(star)}
          onMouseEnter={() => setHover(star)}
          onMouseLeave={() => setHover(0)}
          style={{ cursor: "pointer", fontSize: "1.5rem", marginRight: "5px" }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default Rating;
